export default __webpack_public_path__ + "static/Brett_Bartylla_Resume-8ea103bffdbfc7228057c9c09f7d6186.pdf";